/**
 * useDebugPanel — consumer hook for DebugPanelContext. Split out from the
 * context file so the provider's react-refresh hygiene stays clean.
 */
import { useContext } from 'react';
import { DebugPanelContext, type DebugPanelContextValue } from '../contexts/DebugPanelContext';

export function useDebugPanel(): DebugPanelContextValue {
  const ctx = useContext(DebugPanelContext);
  if (!ctx) {
    throw new Error('useDebugPanel must be used within a DebugPanelProvider');
  }
  return ctx;
}
